"use client";

import Link from "next/link";

export function QuickAddToast({
  message,
  onDismiss,
}: {
  message: string;
  onDismiss: () => void;
}) {
  return (
    <div
      role="status"
      data-testid="quick-add-toast"
      className="fixed bottom-4 left-1/2 z-50 flex max-w-[90vw] -translate-x-1/2 items-center gap-3 rounded-xl bg-brand-text px-4 py-3 text-sm text-white shadow-2xl md:left-auto md:right-6 md:translate-x-0"
    >
      <span className="flex-1">{message}.</span>
      <Link
        href="/cart"
        onClick={onDismiss}
        className="font-semibold text-brand-teal-soft underline-offset-2 hover:underline"
      >
        View cart
      </Link>
    </div>
  );
}
